import Container from "../../components/element/container";
import "./policy.scss";
import PolicyContent from "../../components/policy/policy.content";

export default function PolicyPage({ policy, children }) {
  return (
    <main className="policy-page">
      <Container tag="div" className="policy-page-inner">
        <PolicyContent policy={policy}>{children}</PolicyContent>
      </Container>
    </main>
  );
}
